import { WujieVue } from '@stroybrooke-business-tools/plugins'
import { ref } from 'vue'

const OPEN_CONSUME_SETTLE_EVENT = 'OPEN_CONSUME_SETTLE'
const SETTLEMENT_PAYMENT_READY_TIMEOUT = 3000
const ready = ref(false)

export function markSettlementPaymentReady() {
  ready.value = true
}

export function markSettlementPaymentUnavailable() {
  ready.value = false
}

export function destroySettlementPayment() {
  const shouldDestroy = ready.value
  ready.value = false
  if (!shouldDestroy) return

  try {
    Promise.resolve(WujieVue.destroyApp?.('SettlementPayment')).catch(
      (error) => {
        console.warn('destroy SettlementPayment failed', error)
      },
    )
  } catch (error) {
    console.warn('destroy SettlementPayment failed', error)
  }
}

export async function waitSettlementPaymentReady() {
  if (ready.value) return Promise.resolve()

  return new Promise<void>((resolve) => {
    const startAt = Date.now()
    const timer = window.setInterval(() => {
      if (
        ready.value ||
        Date.now() - startAt > SETTLEMENT_PAYMENT_READY_TIMEOUT
      ) {
        window.clearInterval(timer)
        resolve()
      }
    }, 100)
  })
}

export async function openConsumeSettleWhenReady(payload: any) {
  await waitSettlementPaymentReady()

  WujieVue.bus.$emit(OPEN_CONSUME_SETTLE_EVENT, payload)
  return true
}
